import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import classNames from 'classnames'
import styles from './styles.scss'

const PlanTitle = styled.h2`
  background-color: ${props => props.planColor};
`

const PlanContent = styled.div`
background-color: ${props => props.secondaryPlanColor};

${props => (props.rounded
    ? `
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  ` : ''
  )}
`

const StyledDisclaimerSection = styled.section`
  background-color: ${props => props.secondaryPlanColor};
`

class PlanSummary extends PureComponent {
  handlePlanClick = () => {
    this.props.onButtonClick(this.props)
  }

  renderHeader = () => {
    const {
      planColor,
      title,
    } = this.props

    return (
      <React.Fragment>
        <header
          className={styles.planHeader}
          key={`${title}-header`}
        >
          <PlanTitle planColor={planColor} className={styles.planTitle}>
            {title}
          </PlanTitle>
        </header>
      </React.Fragment>
    )
  }

  renderLimit = () => {
    const { secondaryPlanColor, limit } = this.props
    return (
      <PlanContent secondaryPlanColor={secondaryPlanColor} className={classNames(styles.limit, styles.small)}>
        {limit}
      </PlanContent>
    )
  }

  renderDisclaimer = () => {
    const {
      title, speedDisclaimer, planColor, secondaryPlanColor,
    } = this.props

    return (
      <StyledDisclaimerSection
        className={styles.disclaimer}
        key={`${title}-disclaimer`}
        planColor={planColor}
        secondaryPlanColor={secondaryPlanColor}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: speedDisclaimer,
          }}
        />
      </StyledDisclaimerSection>
    )
  }

  render() {
    const { buttonText, secondaryPlanColor } = this.props
    const defaultClassNames = classNames('planItem', styles.planItem, styles.planSummary)

    const planDetails = [this.renderHeader(), this.renderLimit(), this.renderDisclaimer()]
    return (
      <div className={defaultClassNames}>
        {planDetails}
        <PlanContent rounded className={styles.content} secondaryPlanColor={secondaryPlanColor}>
          <button className={styles.genericButton} onClick={this.handlePlanClick}>
            {buttonText} <i className="kgnIcon kgn-icon-arrow-right" />
          </button>
        </PlanContent>
      </div>
    )
  }
}

PlanSummary.propTypes = {
  planColor: PropTypes.string,
  secondaryPlanColor: PropTypes.string,
  title: PropTypes.string,
  speedDisclaimer: PropTypes.string,
  buttonText: PropTypes.string,
  limit: PropTypes.string,
  onButtonClick: PropTypes.func,
}

PlanSummary.defaultProps = {
  planColor: '',
  secondaryPlanColor: '',
  title: '',
  speedDisclaimer: '',
  buttonText: '',
  limit: '',
  onButtonClick: f => f,
}

export default PlanSummary



// WEBPACK FOOTER //
// ./components/PlanItem/PlanSummary.jsx